import React from 'react';
import { EDITOR_VIEW_NAME } from '../core/constants';
import { translate } from '../core/i18n';
import { store } from '../core/state';
import { isResponsiveView } from '../features/responsive';
import { EditProjectData } from './EditProjectData';
import { FullscreenOverlay } from './FullscreenOverlay';
import { BaseModal } from './modals/BaseModal';

export const EditProjectDataModal: React.FC = () => {
  // Use store.useState instead of getViewData to properly subscribe to changes
  const [editorState, setEditorState] = store.useState(EDITOR_VIEW_NAME);
  const showEditData = editorState?.data?.editDataVisible;
  const responsiveView = isResponsiveView();

  if (!showEditData) {
    return null;
  }

  const handleClose = () => {
    setEditorState({
      ...editorState,
      data: {
        ...editorState.data,
        editDataVisible: false
      }
    });
  };

  const title = translate('edit-data-menu');

  // Mobile: FullscreenOverlay
  if (responsiveView) {
    return (
      <FullscreenOverlay 
        title={title}
        onClose={handleClose}
      >
        <EditProjectData />
      </FullscreenOverlay>
    );
  }

  // Desktop: Modal
  return (
    <BaseModal
      title={title}
      handleClose={handleClose}
      show={showEditData}
      childBody={<EditProjectData />}
    />
  );
};

export default EditProjectDataModal;

